<button
  type="button"
  class="tooltip-button"
  tabindex="-1"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel || text"
  (click)="$event.preventDefault(); $event.stopPropagation(); tooltip.toggle()"
  [matTooltip]="text"
  [matTooltipDisabled]="disabled"
  [matTooltipClass]="'universalTooltip ' + tooltipClass"
  #tooltip="matTooltip">
  @if (!svgIcon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
  @if (svgIcon) {
    <mat-icon [svgIcon]="svgIcon"></mat-icon>
  }
</button>
